class CollectionPromoTile extends HTMLElement {
  constructor() {
    super();

    this.positionInGrid = parseInt(this.getAttribute("data-collection-promo-tile-position"), 10) || 3;
    
    this.initPromoTile();
  }

  initPromoTile() {
    try {
      this.checkCollectionStatus();
    } catch (error) {
      console.error('There was a problem with the Collection Promo Tile element:', error);
    }
  }

  checkCollectionStatus() {
    this.productGrid = document.querySelector('#product-grid');

    if (!this.productGrid) { return; }

    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('product__grid__item')) {
              this.insertPromoTile();
              observer.disconnect();
              return;
            }
          }
        }
      }
    });

    observer.observe(this.productGrid, { childList: true, subtree: true });
  }

  insertPromoTile() {
    const gridItems = Array.from(this.productGrid.children);
    const insertIndex = Math.min(this.positionInGrid - 1, gridItems.length);

    if (insertIndex >= gridItems.length) {
      this.productGrid.appendChild(this);
    } else {
      this.productGrid.insertBefore(this, gridItems[insertIndex]);
    }

    this.classList.add('active');
  }
}

customElements.define('collection-promo-tile', CollectionPromoTile);

const CountdownClock = class extends HTMLElement {
  constructor () {
    super();

    this.countdownDate = Number(this.dataset.date);
    this.date = new Date(this.countdownDate);
    this.daysEl = this.querySelector('[data-days]');
    this.hoursEl = this.querySelector('[data-hours]');
    this.minutesEl = this.querySelector('[data-minutes]');
    this.secondsEl = this.querySelector('[data-seconds]');

    this.initCountdown();
  }

  initCountdown () {
    const countdown = setInterval(() => {
      const now = new Date().getTime();
      const difference = this.date - now;

      if (difference < 1) {
        this.stopInterval(countdown);
        return;
      }

      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      this.daysEl.innerText = days.toString().length === 1 ? `0${days}` : days;
      this.hoursEl.innerText = hours.toString().length === 1 ? `0${hours}` : hours;
      this.minutesEl.innerText = minutes.toString().length === 1 ? `0${minutes}` : minutes;
      this.secondsEl.innerText = seconds.toString().length === 1 ? `0${seconds}` : seconds;
    }, 1000);
  }

  stopInterval (interval) {
    this.classList.add('hide');
    clearInterval(interval);
  }
}

customElements.define('countdown-clock', CountdownClock);
